import { getCadenceOption, getCadenceColor } from './Drawer/Cadence/helpers';

// Base columns that are always present
export const BASE_COLUMNS = [
  { 
    id: 1, 
    name: 'Inicio', 
    style: { 
      background: '#f5f5f5', 
      color: '#722ed1', 
      fontSize: '20px', 
      textAlign: 'center' 
    }, 
    data: [],
    type: 'base'
  },
  { 
    id: 2, 
    name: 'Leads', 
    style: { 
      background: '#f5f5f5', 
      color: '#1890ff', 
      fontSize: '20px', 
      textAlign: 'center' 
    }, 
    data: [],
    type: 'base'
  },
  { 
    id: 4, 
    name: 'Positivo', 
    style: { 
      background: '#f5f5f5', 
      color: '#52c41a', 
      fontSize: '20px', 
      textAlign: 'center'  
    }, 
    data: [], 
    hidden: false,
    type: 'base'
  },
  { 
    id: 5, 
    name: 'Negativo', 
    style: { 
      background: '#f5f5f5', 
      color: '#f5222d', 
      fontSize: '20px', 
      textAlign: 'center'  
    }, 
    data: [],
    hidden: false,
    type: 'base'
  }
];

// Legacy columns for backward compatibility
export const COLUMNS = [
  { 
    id: 1, 
    name: 'Leads', 
    style: { 
      background: '#f5f5f5', 
      color: '#722ed1', 
      fontSize: '20px', 
      textAlign: 'center' 
    }, 
    data: [] 
  },
  { 
    id: 2, 
    name: 'Prospecção',  
    style: { 
      background: '#f5f5f5', 
      color: '#1890ff', 
      fontSize: '20px', 
      textAlign: 'center'  
    }, 
    data: []
  },
  { 
    id: 3, 
    name: 'Convertidos',  
    style: { 
      background: '#f5f5f5', 
      color: '#000', 
      fontSize: '20px', 
      textAlign: 'center'  
    }, 
    data: []
  },
  { 
    id: 4, 
    name: 'Positivo', 
    style: { 
      background: '#f5f5f5', 
      color: '#52c41a', 
      fontSize: '20px', 
      textAlign: 'center'  
    }, 
    data: [], 
    hidden: false
  },
  { 
    id: 5, 
    name: 'Negativo', 
    style: { 
      background: '#f5f5f5', 
      color: '#f5222d', 
      fontSize: '20px', 
      textAlign: 'center'  
    }, 
    data: [],
    hidden: false
  }
];

// Function to generate step columns based on cadence data
export const generateStepColumns = (cadenceData) => {
  if (!cadenceData || !cadenceData.data || !Array.isArray(cadenceData.data)) {
    return [];
  }

  return cadenceData.data.map((step, index) => {
    // Use the actual type string from the backend, or fallback to getCadenceOption if it's numeric
    let stepName;
    if (typeof step.type === 'string' && isNaN(parseInt(step.type))) {
      // Use the string type directly (e.g., "Msg1", "Curtir", "Áudio")
      stepName = step.type;
    } else {
      // Fallback to numeric type handling
      const stepType = parseInt(step.type);
      stepName = getCadenceOption(stepType) || step.type;
    }
    
    // For color, try to use numeric type if available, otherwise use default
    const stepColor = !isNaN(parseInt(step.type)) ? getCadenceColor(parseInt(step.type)) : '#007bff';
    
    return {
      id: `step_${step.uid}`,
      name: stepName,
      style: {
        background: '#f5f5f5',
        color: stepColor,
        fontSize: '20px',
        textAlign: 'center'
      },
      data: [],
      type: 'step',
      stepData: step,
      stepIndex: index
    };
  });
};

// Function to generate complete column structure
export const generateColumns = (cadenceData) => {
  const baseColumns = [...BASE_COLUMNS];
  const stepColumns = generateStepColumns(cadenceData);
  
  // Insert step columns between Leads and Positivo
  const inicioColumn = baseColumns.find(col => col.id === 1);
  const leadsColumn = baseColumns.find(col => col.id === 2);
  const positiveColumn = baseColumns.find(col => col.id === 4);
  const negativeColumn = baseColumns.find(col => col.id === 5);
  
  return [
    inicioColumn,
    leadsColumn,
    ...stepColumns,
    positiveColumn,
    negativeColumn
  ].filter(Boolean);
};

export const DEFAULT_DRAWER_STATE = {
  data: {
    id: null,
  },
  show: false
};

export const DEFAULT_SUMMARY_DRAWER_STATE = {
  summaryData: null,
  leads: [],
  show: false,
  isLoading: false
}; 